import Image from 'next/image';
import Link from 'next/link';

import { cx } from 'class-variance-authority';

import { Corporate5050Props } from '@oresundsbron/api/src/types/contentful';

import { Button } from '@oresundsbron/bridge-ui';
import { useLinks } from '~/hooks/useLinks';

interface Corporate5050ComponentProps {
  content: Corporate5050Props;
}

function Corporate5050({
  content: {
    title,
    preamble,
    link,
    linkText,
    media,
    mediaAlignedLeft,
    backgroundColor,
  },
}: Corporate5050ComponentProps) {
  const { getLink } = useLinks();
  const bgColorVariants = {
    'blue-700': 'bg-blue-700',
    'blue-800': 'bg-blue-800',
  };

  return (
    <div className={bgColorVariants[backgroundColor]}>
      <div className="grid grid-rows-2 sm:grid-cols-2 sm:grid-rows-1">
        <div>
          {media?.url && (
            <Image
              className="aspect-video h-full w-full object-cover"
              src={media.url}
              alt={media.description || ''}
              width={720}
              height={720}
            />
          )}
        </div>

        <div
          className={cx(
            'flex flex-col justify-center px-4 py-6 text-white sm:px-16',
            mediaAlignedLeft ? '' : 'sm:-order-1'
          )}
        >
          <div
            className="mb-4 text-lg font-semibold sm:text-2xl"
            role="heading"
            aria-level={2}
          >
            {title}
          </div>
          <p className="font-normal sm:text-xl">{preamble}</p>

          {link?.slug && linkText && (
            <div>
              <Button
                className="mt-6 sm:mt-8"
                as={Link}
                href={getLink(link?.sys.id)?.path!}
                color="white"
                intent="outlined"
              >
                {linkText}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Corporate5050;
